import { render, staticRenderFns } from "./RichTextToolbar.vue?vue&type=template&id=004d6e44&scoped=true"
import script from "./RichTextToolbar.vue?vue&type=script&lang=js"
export * from "./RichTextToolbar.vue?vue&type=script&lang=js"
import style0 from "./RichTextToolbar.vue?vue&type=style&index=0&id=004d6e44&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d6e44",
  null
  
)

export default component.exports